import { api } from './client'

// SmartLabSettings is the frontend-safe view. The password is never returned —
// has_password only reports whether one is stored.
export interface SmartLabSettings {
    enabled: boolean
    base_url: string
    username: string
    has_password: boolean
    updated_at?: string
}

export interface UpdateSmartLabSettingsRequest {
    enabled: boolean
    base_url: string
    username: string
    // password: omit or leave empty to keep the stored one.
    password?: string | null
}

export const smartLabSettingsApi = {
    get: () => api.get<SmartLabSettings>('/smartlab/settings'),
    update: (data: UpdateSmartLabSettingsRequest) =>
        api.put<SmartLabSettings>('/smartlab/settings', data),
}
